"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dictatorship = _interopRequireDefault(require("./dictatorship"));

var rules = {
  dictatorship: _dictatorship["default"]
};
var _default = rules;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9SdWxlU2V0L3NldHMvaW5kZXgudHMiXSwibmFtZXMiOlsicnVsZXMiLCJkaWN0YXRvcnNoaXAiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUNBOztBQUVBLElBQU1BLEtBQWdDLEdBQUc7QUFDdkNDLEVBQUFBLFlBQVksRUFBWkE7QUFEdUMsQ0FBekM7ZUFJZUQsSyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSdWxlU2V0IGZyb20gJy4uJztcbmltcG9ydCBkaWN0YXRvcnNoaXAgZnJvbSAnLi9kaWN0YXRvcnNoaXAnO1xuXG5jb25zdCBydWxlczoge1tuYW1lOiBzdHJpbmddOiBSdWxlU2V0fSA9IHtcbiAgZGljdGF0b3JzaGlwLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgcnVsZXM7XG4iXX0=